import React from 'react';
import { Button } from 'reactstrap';
import { Dialog } from 'primereact/dialog';
import '../../micro/cotizacion/styleDialogNorm.css'
export const ModalNormExam = ({
    modalExams,
    handleToggleExams,
    detailNorm
}) => {

    console.log("🦀 detailNorm", detailNorm);

    const footer = (
        <div className="profile-modal-footer">
            <Button
                color="primary"
                onClick={handleToggleExams}
            >
                Entendido
            </Button>
        </div>
    );

    return (
        <Dialog
            header={
                <div className="profile-modal-header">
                    <i className="fa fa-book"></i>
                    <span>Normas</span>
                </div>
            }
            visible={modalExams}
            onHide={handleToggleExams}
            modal
            closable
            blockScroll
            className="medium-dialog"
            footer={footer}
        >

            <div className="profile-modal-description">

                <div
                    style={{
                        padding: "12px",
                        borderRadius: "10px",
                        background: "#f8fafc",
                        marginBottom: "15px"
                    }}
                >
                    <strong>Estudio:</strong>
                    <br />
                    <strong>{detailNorm?.name || "Sin nombre"}</strong>
                </div>

                <small>
                    Las siguientes normas pertenecen a este estudio.
                </small>

            </div>

            <div className="profile-exams-list">

                {detailNorm?.id_profile !== null ? (

                    detailNorm?.profileRulesDetail?.length > 0 ? (

                        detailNorm.profileRulesDetail.map((examRule, index) => {

                            const examInfo = detailNorm?.listExams?.find(
                                x => Number(x.id_exam) === Number(examRule.id_exam)
                            );

                            return (

                                <div
                                    key={index}
                                    className="norm-group-card"
                                >

                                    <div className="norm-group-header">

                                        <div className="norm-group-icon">
                                            <i className="fa fa-flask"></i>
                                        </div>

                                        <div className="norm-group-title">
                                            {examInfo?.name || `Examen ${examRule.id_exam}`}
                                        </div>

                                    </div>

                                    <div className="norm-group-rules">

                                        {examRule.rules?.map((rule, idx) => (

                                            <div
                                                key={idx}
                                                className="norm-rule-item"
                                            >
                                                <i className="fa fa-book"></i>
                                                <span>{rule.norm}</span>
                                            </div>

                                        ))}

                                    </div>

                                </div>

                            );
                        })

                    ) : (

                        <div className="text-center text-muted p-3">
                            No existen normas asociadas.
                        </div>

                    )

                ) : (

                    detailNorm?.listNorm?.length > 0 ? (

                        <div className="norm-group-card">

                            <div className="norm-group-header">

                                <div className="norm-group-icon">
                                    <i className="fa fa-flask"></i>
                                </div>

                                <div className="norm-group-title">
                                    {detailNorm?.name}
                                </div>

                            </div>

                            <div className="norm-group-rules">

                                {detailNorm.listNorm.map((rule, index) => (

                                    <div
                                        key={index}
                                        className="norm-rule-item"
                                    >
                                        <i className="fa fa-book"></i>
                                        <span>{rule.name}</span>
                                    </div>

                                ))}

                            </div>

                        </div>

                    ) : (

                        <div className="text-center text-muted p-3">
                            No existen normas asociadas.
                        </div>

                    )

                )}

            </div>
        </Dialog>
    );
};